import { render } from "./Microsoft.vue?vue&type=template&id=b09ba52a&scoped=true"
import script from "./Microsoft.vue?vue&type=script&lang=js"
export * from "./Microsoft.vue?vue&type=script&lang=js"

import "./Microsoft.vue?vue&type=style&index=0&id=b09ba52a&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b09ba52a"]])

export default __exports__